<template>
    <!-- 房客管理 -->
    <div>
        <div class="tenant_title">
            房客查询
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="输入查询：">
                <el-input
                    v-model="formInline.searchValue"
                    placeholder="请输入会员名称或电话"
                    clearable
                ></el-input>
            </el-form-item>
            <!-- 选择时间 -->
            <el-form-item label="创建时间：" class="left_margin">
                <el-date-picker
                    v-model="time"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    size="small"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="left"
                    prefix-icon="el-icon-date"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="消费金额：" class="money">
                <el-input
                    v-model="money.moneyMin"
                    placeholder="最低价"
                    clearable
                ></el-input>
                <div class="zhi">至</div>
                <el-input
                    v-model="money.moneyMax"
                    placeholder="最高价"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item class="left_margin">
                <el-button type="primary" @click="getTenant"
                >搜索
                </el-button
                >
                <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="newly_built" style="display: inline-flex">
            <el-button
                type="primary"
                icon="el-icon-plus"
                @click="handleAdd"
                v-if="premission('New:Guest:Information')"
            >新建
            </el-button
            >

            <el-button type="primary" v-if="premission('Export:Guest')" @click="exportData"
            >导出
            </el-button
            >
            &nbsp;&nbsp;&nbsp;
            <el-upload
                class="upload-demo"
                action=""
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="importHourseExcel"
            >
                <el-button
                    type="primary"
                    v-if="premission('Export:Listing:list')"
                >导入
                </el-button>
            </el-upload>
        </div>
        <!-- 表单区域 -->
        <el-table
            ref="multipleTable"
            :data="tenanttableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="customerId" label="会员编号"></el-table-column>
            <el-table-column prop="nickName" label="会员昵称"></el-table-column>
            <el-table-column prop="phonenumber" label="手机号"></el-table-column>
            <el-table-column prop="city" label="常住城市"></el-table-column>
            <el-table-column prop="createTime" label="注册时间"></el-table-column>
            <el-table-column prop="cusDefine1" label="订房天数"></el-table-column>
            <el-table-column prop="moneyTotal" label="消费金额"></el-table-column>
            <el-table-column prop="isRealName" label="实名认证">
                <template slot-scope="scope">
                    {{ scope.row.isRealName == 1 ? "是" : "否" }}
                </template>
            </el-table-column>
            <el-table-column prop="loginDate" label="上次登录时间"></el-table-column>
            <el-table-column prop="registeredSource" label="注册来源"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="details(scope.row)"
                    >查看
                    </el-button
                    >
                </template
                >
            </el-table-column>
        </el-table>
        <!-- <div class="checkBox"></div> -->
        <!-- 分页 -->
        <div class="paging">
            <div class="block">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[8, 16, 24, 32]"
                    :page-size="8"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 新建弹出框 -->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="600px"
            :show-close="false"
        >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="customerName">
                    <el-input
                        v-model="ruleForm.customerName"
                        placeholder="客户真实姓名（必填）"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model="ruleForm.nickName"
                        placeholder="会员昵称（选填）"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phonenumber">
                    <el-input
                        v-model="ruleForm.phonenumber"
                        placeholder="请输入手机号（必填）"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item
                  prop="params.verification"
                  :rules="[
                    { required: true, message: '请填写验证码', trigger: 'blur' }
                  ]"
                >
                  <el-input
                    class="verification"
                    v-model="ruleForm.params.verification"
                    placeholder="请输入验证码"
                  ></el-input>
                  <div v-if="show" class="gain">
                    <button @click="getCode" class="verification_btn">
                      获取验证码
                    </button>
                  </div>
                  <div v-if="!show" class="gain">{{ count }} s</div>
                </el-form-item> -->
                <!-- <el-form-item prop="NewPassword">
                  <el-input
                    show-password
                    v-model="ruleForm.NewPassword"
                    placeholder="创建密码"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    show-password
                    v-model="ruleForm.params.password"
                    placeholder="确认密码"
                  ></el-input>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('ruleForm')" class="cancel">取 消</el-button>
        <el-button
            type="primary"
            @click="add_new_btn('ruleForm')"
            class="add_new_btn"
        >确 定</el-button
        >
      </span>
        </el-dialog>
    </div>
</template>

<script>
import {addDateRange, money} from "../../utils/treating";
import {exportUser} from "@/api/export"
import {
    getTenantAjax,
    TenantcustomerAjax,
    sendPhoneCodeAjax, importTenantExcel
} from "../../api/index";
import premission from "../../utils/permission";

export default {
    mixins: [premission],
    data() {
        var phonenumber = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("手机号码不能为空"));
            } else if (!/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
                callback(new Error("手机号码格式错误!"));
            } else {
                callback();
            }
        };
        var validatorPassword = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("账号不能为空"));
            } else if (!/^[a-zA-Z0-9]{6,18}$/.test(value)) {
                callback(new Error("账号格式错误,必须且只含有数字和字母，6-18位!"));
            } else {
                callback();
            }
        };
        // 再次输入新密码
        // var validatorCheckPass = (rule, value, callback) => {
        //   console.log(value);
        //   if (value === "") {
        //     callback(new Error("请再次输入密码"));
        //   } else if (value !== this.ruleForm.params.password) {
        //     console.log(this.value);
        //     callback(new Error("两次输入密码不一致!"));
        //   } else {
        //     callback();
        //   }
        // };
        return {
            // 表单验证
            rules: {
                customerName: [
                    {required: true, message: "请填写客户真实姓名", trigger: "blur"}
                ],
                phonenumber: [
                    {validator: phonenumber, required: true, trigger: "blur"}
                ],
                NewPassword: [
                    {required: true, validator: validatorPassword, trigger: "blur"}
                ]
                // verification: [
                //   { required: true, message: "请填写验证码", trigger: "blur" }
                // ]
                // password: [
                //   { required: true, validator: validatorCheckPass, trigger: "blur" }
                // ]
            },
            title: "新建客户",
            dialogVisible: false,
            // 时间
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            show: true,
            count: "",
            timer: null,

            // 密码

            // 新建数据
            ruleForm: {
                customerName: "",
                nickName: "",
                // NewPassword: "",
                // params: { verification: "", password: "" },
                phonenumber: ""
            },
            // 消费金额
            money: {
                moneyMin: "",
                moneyMax: ""
            },
            // 选择时间
            time: [],
            // 搜索条件
            formInline: {
                pageNum: 1,
                pageSize: 8,
                searchValue: undefined
            },
            total: 0,
            currentPage: 1,
            tenanttableData: [],
            selectData: [],//选中的列表数组
        };
    },
    created() {
        this.getTenant();
    },
    methods: {
        exportData() {
            //导出
            var obj = {}
            if (this.selectData.length > 0) {
                obj.list = this.selectData
            }
            exportUser(obj).then(result => {
                console.log(result)
            })
        },
        //导入
        importHourseExcel(data){
            console.log(data)
            let fromData=new FormData();
            fromData.append("file",data.raw)
            importTenantExcel(fromData).then(res=>{
                console.log(res)
                if(res.data.code==0){
                    this.$message.success('导入成功')
                    this.getTenant();
                }else {
                    this.$message.error(res.data.msg)
                }

            })
        },
        // 新建
        handleAdd() {
            this.dialogVisible = true;
        },

        reset() {
            this.formInline = {
                pageNum: 1,
                pageSize: 8,
                searchValue: undefined
            };
            this.time = [];
            this.money = {
                moneyMin: "",
                moneyMax: ""
            };
            this.getTenant();
        },
        // 取消按钮
        handleClose(done) {
            done();
        },
        // 全选
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 反选
        handleSelectionChange(arr) {
            console.log(arr);
            this.selectData = arr;
        },
        // 获取列表数据
        async getTenant() {
            const {data: res} = await getTenantAjax(
                money(this.formInline, this.money, this.time)
            );
            this.tenanttableData = res.rows;
            this.total = res.total;
        },
        // 查看跳转详情
        details(e) {
            this.$router.push({
                name: "tenantParticulars", //跳转的路径
                params: {
                    customerId: e.customerId
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.getTenant();
        },
        handleCurrentChange(val) {
            this.formInline.pageNum = val;
            this.getTenant();
        },
        add_new_btn(ruleForm) {
            this.$refs[ruleForm].validate(async valid => {
                if (valid) {
                    // if (this.ruleForm.NewPassword !== this.ruleForm.params.password)
                    //   return this.$message({
                    //     message: "两次输入不一致，请重新输入",
                    //     type: "error"
                    //   });
                    const {data: res} = await TenantcustomerAjax(this.ruleForm);
                    if (res.code !== 200)
                        return this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    this.$refs[ruleForm].resetFields();
                    this.ruleForm = {
                        customerName: "",
                        nickName: "",
                        // NewPassword: "",
                        // params: { verification: "", password: "" },
                        phonenumber: ""
                    };
                    this.getTenant();
                    this.dialogVisible = false;
                    return this.$message({
                        message: res.msg,
                        type: "success"
                    });
                } else {
                    return false;
                }
            });
        },
        cancel(ruleForm) {
            this.dialogVisible = false;
            this.$refs[ruleForm].resetFields();
            this.ruleForm = {
                customerName: "",
                nickName: "",
                // NewPassword: "",
                // params: { verification: "", password: "" },
                phonenumber: ""
            };
        },
        // 获取验证码按钮
        async getCode() {
            if (this.ruleForm.phonenumber == "")
                return this.$message({
                    message: "请填写手机号",
                    type: "error"
                });
            const TIME_COUNT = 10;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
            const {data: res} = await sendPhoneCodeAjax({
                phone: this.ruleForm.phonenumber
            });
        }
    }
};
</script>

<style lang="less" scoped>
.tenant_title {
    width: 72px;
    height: 24px;
    font-size: 18px;
    line-height: 24px;
    color: #171a1e;
    margin-bottom: 20px;
}

/deep/ .demo-form-inline {
    .el-input__inner {
        width: 250px;
        height: 36px;
        font-size: 14px;
    }

    .left_margin {
        margin-left: 26px;
    }

}

/deep/ .el-range-separator {
    width: 10%;
}

/deep/ .el-range-editor.el-input__inner {
    float: left;
    margin-top: 2px;
}

/deep/ .el-date-editor .el-range-separator {
    line-height: 28px;
}

.newly_built {
    margin-bottom: 20px;
}

.money {
    margin-left: 26px;

    /deep/ .el-form-item__content {
        width: 244px;
        padding-top: 3px;
    }

    div {
        float: left;
    }

    .zhi {
        width: 44px;
        text-align: center;
    }

    /deep/ .el-input {
        width: 100px;
    }

    /deep/ .el-input__inner {
        padding-left: 25px;
        float: left;
        width: 100px;
        height: 36px;
    }
}

.checkBox {
    width: 100%;
    height: 50px;
    background: #f2f2f2;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    border-radius: 0px;
}

.paging {
    margin-top: 40px;
    margin-left: 610px;
}

/deep/ .el-table__header-wrapper {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    height: 50px;
    border-radius: 0px;

    .el-table__header {
        height: 50px;

        tr {
            height: 50px;

            th {
                background-color: #f2f2f2;
                text-align: center;
            }
        }
    }
}

/deep/ .el-table__row td {
    text-align: center;
    height: 60px;
    padding: 4px 0;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #f6b439;
}

/deep/ .el-dialog__header {
    text-align: center;
    padding-top: 50px;
    font-size: 20px;
}

/deep/ .el-dialog__body {
    padding: 30px 60px;

    .el-form-item {
        height: 36px;
        margin-bottom: 25px;

        .el-form-item__content {
            height: 36px;

            .gain {
                display: inline-block;
                width: 110px;
                height: 36px;
                text-align: center;
                line-height: 36px;
                color: #b9b9b9;
            }

            .el-input__inner {
                height: 36px;
            }
        }
    }
}

/deep/ .el-dialog {
    border-radius: 10px;
}

/deep/ .el-dialog__footer {
    padding: 15px 60px 40px;

    .add_new_btn {
        background-color: #f6b439;
        border: 1px solid #f6b439;
    }

    .cancel {
        background: #f2f2f2;
        border: 1px solid #e1e1e1;
    }
}

.verification {
    width: 370px;
}

.verification_btn {
    border: none;
    width: 110px;
    height: 36px;
    line-height: 36px;
    color: #f6b439;
    background-color: #fff;
}
</style>
